let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j7W9N")).then(() => parcelRequire('gLFT8'));